import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getLightningGroupsAPI() {
  const url = `${AWS_API_URL}/lighting/groups`;

  return getRequest(url, await authorize());
}
